"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcTime(props) {
  var onChange = props.onChange,
    defaultOpenValue = props.defaultOpenValue,
    allowClear = props.allowClear,
    disabled = props.disabled,
    className = props.className,
    value = props.value,
    use12Hours = props.use12Hours,
    onSelect = props.onSelect,
    disabledTime = props.disabledTime,
    format = props.format,
    hourStep = props.hourStep,
    minuteStep = props.minuteStep,
    inputReadOnly = props.inputReadOnly,
    placement = props.placement,
    status = props.status;
  defaultOpenValue = (0, _moment["default"])('00:00', 'HH:mm a');
  return /*#__PURE__*/_react["default"].createElement(_lib.TimePicker, {
    allowClear: allowClear ? allowClear : false,
    disabled: disabled ? disabled : false,
    popupClassName: className ? className : '',
    value: value,
    use12Hours: use12Hours ? use12Hours : false,
    onSelect: onSelect,
    disabledTime: disabledTime,
    format: format,
    hourStep: hourStep ? hourStep : 1,
    status: status,
    minuteStep: minuteStep ? minuteStep : 1,
    inputReadOnly: inputReadOnly ? inputReadOnly : false,
    placement: placement ? placement : '',
    onChange: onChange,
    defaultOpenValue: defaultOpenValue
  });
}
var _default = ArcTime;
exports["default"] = _default;